"use strict";

(function ($, Drupal, drupalSettings) {
  /**
   * Ultil functions to filter and advanced filter in product and specifications
   *
   * @type {{attach: attach}}
   */
  Drupal.behaviors.searchFilterUtils = {
    /**
     * Get a URL with the filters checked.
     *
     * @param context
     *   Affected piece of HTML.
     * @param regionSelector
     *   Selected region.
     * @returns {*}
     */

    getUrl: (context, regionSelector, noFilters) => {
      var url = window.location.pathname;
      var fieldsChecked = $(regionSelector).find(":checked");
      var queryString = [];
      var qs = [];
      var $el = null;
      var search = false;

      if (window.location.search) {
        qs = decodeURIComponent(window.location.search)
          .replace("?", "")
          .split("&");
        for (var i = 0, l = qs.length; i < l; i++) {
          if (!qs[i].match("^filters") && !qs[i].match("^last")) {
            queryString.push(qs[i]);
          }
        }
        search = true;
      }

      if (fieldsChecked.length == 0 && search == false) {
        return url;
      }

      if (noFilters !== "noFilters") {
        for (var _i = 0, _l = fieldsChecked.length; _i < _l; _i++) {
          $el = $(fieldsChecked[_i]);
          queryString.push(
            `filters[${$el.data("field")}][${_i}]=${encodeURIComponent(
              $el.val()
            )}`
          );
        }
      }

      return { url: url, queryString: queryString.join("&") };
    },
    /**
     * Remove filter checked.
     * @param context
     *   Affected piece of HTML.
     *
     */
    removeFilters: function removeFilters(context) {
      $(
        "#js-search-filters .eprc-input:checked, #js-search-filters-mobile .eprc-input:checked",
        context
      )
        .prop("checked", false)
        .removeClass("item-unavailable");
    },
    /**
     * Return the value of Lang-Country parameter if exists.
     *
     * @param context
     *   Affected piece of HTML.
     */
    getLangCountryParameter: function getLangCountryParameter(context) {
      let sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split("&"),
        sParameterName = void 0,
        i = void 0;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split("=");

        if (sParameterName[0] === "lang") {
          return sParameterName[1] === undefined ? true : sParameterName[1];
        }
      }
    },
    /**
     * Check filters from the parameters URL.
     *
     * @param regionSelector
     *   Selected region.
     */
    checkFiltersFromParameters: function checkFiltersFromParameters(
      regionSelector
    ) {
      const queryStringParams = decodeURIComponent(window.location.search);
      const regexPatterns = "filters\\[(.+)\\].+=(.+)$";

      if (queryStringParams.length === 0) {
        return;
      }

      let i = void 0,
        l = void 0,
        array = void 0,
        match = void 0,
        value = void 0;

      array = queryStringParams.split("&");

      for (i = 0, l = array.length; i < l; i++) {
        match = new RegExp(regexPatterns, "gi").exec(array[i]);

        if (!match) {
          continue;
        }

        value = decodeURIComponent(match[2]);
        $(regionSelector)
          .find('*[data-field="' + match[1] + '"][value="' + value + '"]')
          .prop("checked", true);
      }
    },
    /**
     * Count amount of filters applied.
     *
     * @param context
     *   Piece of HTLM affected.
     */
    count: function count(context) {
      const regionSelector = "#dl-menu";
      const totalSelector = "#eprc-filter-total-checked";
      const removeAllSelector = "#js-remove-all-filters-block";
      let total = $(regionSelector).find(":checked").length;

      let totalLabel = "";

      if (total > 0) {
        totalLabel = `(${total})`;
        $(removeAllSelector, context).removeClass("invisibility");
      } else {
        $(removeAllSelector, context).addClass("invisibility");
      }

      $(totalSelector).text(totalLabel);

      $(removeAllSelector).on("click", "#js-remove-all-filters", () => {
        let url = window.location.href;
        url = url.split("?");
        window.open(url[0], "_self");
      });
    },
    /**
     * Disable Pledget Size
     *
     * @param context
     *   Piece of HTLM affected.
     */
    disablePledgetSize: (context) => {
      if ($(".field_special-wrapper input.pledget", context).length) {
        if (
          !$(".field_special-wrapper input.pledget", context).is(":checked")
        ) {
          $("#field_pledget_size li", context).each(function () {
            let selectorThis = $(this);
            let selectorInput = selectorThis.find("input");
            if (selectorInput.is(":checked")) {
              $(selectorInput).trigger("click");
            }
          });
        }
      }
      Drupal.behaviors.searchFilterUtils.getSpecialClicked(context);
    },
    /**
     * Special Clicked to Disable Pledget Size
     *
     * @param context
     *   Piece of HTLM affected.
     */
    getSpecialClicked: (context) => {
      if ($(".field_special-wrapper input.pledget", context).length) {
        if (
          !$(".field_special-wrapper input.pledget", context).is(":checked")
        ) {
          $("#field_pledget_size li").addClass("item-disabled");
        }
      }
    },
    /**
     * Share Desktop To Mobile
     */
    shareDesktopToMobile: () => {
      let widthWindow = $(window).width();
      Drupal.behaviors.searchFilterUtils.getWidthWindow(widthWindow);
    },
    /**
     * Get window resolution and apply url replace if mobile
     *
     * @param widthWindow
     *   width size of window
     */
    getWidthWindow: (widthWindow) => {
      if (widthWindow <= 976) {
        let urlCurrent = window.location.href;
        let isAdvancedActive = urlCurrent.search("advanced=active");

        if (isAdvancedActive > 0) {
          urlCurrent = urlCurrent.replace("advanced=active", "");
          location.replace(urlCurrent);
        }
      }
    },
  };
})(jQuery, Drupal, drupalSettings);
//# sourceMappingURL=jnjethicon-search-filter.js.map
